import {createSlice} from '@reduxjs/toolkit'
import {
  createOmsOrderAsync,
  saveOmsOrderCustomFieldsAsync,
  updateOmsOrderAsync,
  updateOmsOrderAllocationAsync
} from '../actions/omsOrderActions'

interface OmsOrderState {
  saving: boolean
  error: string | null
}

const initialState: OmsOrderState = {
  saving: false,
  error: null,
}

const omsOrderSlice = createSlice({
  name: 'omsOrder',
  initialState,
  reducers: {
    clearOmsOrderError: (state) => {
      state.error = null
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(createOmsOrderAsync.pending, (state) => {
        state.saving = true
        state.error = null
      })
      .addCase(createOmsOrderAsync.fulfilled, (state) => {
        state.saving = false
      })
      .addCase(createOmsOrderAsync.rejected, (state, action) => {
        state.saving = false
        state.error = action.error.message || 'Failed to create order'
      })
      .addCase(saveOmsOrderCustomFieldsAsync.pending, (state) => {
        state.saving = true
      })
      .addCase(saveOmsOrderCustomFieldsAsync.fulfilled, (state) => {
        state.saving = false
      })
      .addCase(saveOmsOrderCustomFieldsAsync.rejected, (state, action) => {
        state.saving = false
        state.error = action.error.message || 'Failed to save order custom fields'
      })
      .addCase(updateOmsOrderAsync.pending, (state) => {
        state.saving = true
        state.error = null
      })
      .addCase(updateOmsOrderAsync.fulfilled, (state) => {
        state.saving = false
      })
      .addCase(updateOmsOrderAsync.rejected, (state, action) => {
        state.saving = false
        state.error = action.error.message || 'Failed to update order'
      })
      .addCase(updateOmsOrderAllocationAsync.pending, (state) => {
        state.saving = true
        state.error = null
      })
      .addCase(updateOmsOrderAllocationAsync.fulfilled, (state) => {
        state.saving = false
      })
      .addCase(updateOmsOrderAllocationAsync.rejected, (state, action) => {
        state.saving = false
        state.error = action.error.message || 'Failed to update order allocation'
      })
  },
})

export const {clearOmsOrderError} = omsOrderSlice.actions
export default omsOrderSlice.reducer
